export var DocsBlockItemPropertyRichTextStyle;
(function (DocsBlockItemPropertyRichTextStyle) {
    /** Title type 1, roughly equivalent of h2 in size */
    DocsBlockItemPropertyRichTextStyle["title1"] = "Title1";
    /** Title type 2, roughly equivalent of h3 in size */
    DocsBlockItemPropertyRichTextStyle["title2"] = "Title2";
    /** Title type 3, roughly equivalent of h4 in size */
    DocsBlockItemPropertyRichTextStyle["title3"] = "Title3";
    /** Title type 4, roughly equivalent of h5 in size */
    DocsBlockItemPropertyRichTextStyle["title4"] = "Title4";
    /** Title type 5, roughly equivalent of h6 in size */
    DocsBlockItemPropertyRichTextStyle["title5"] = "Title5";
    /** Quote */
    DocsBlockItemPropertyRichTextStyle["quote"] = "Quote";
    /** Callout */
    DocsBlockItemPropertyRichTextStyle["callout"] = "Callout";
    /** Ordered list */
    DocsBlockItemPropertyRichTextStyle["ol"] = "OL";
    /** Unordered list */
    DocsBlockItemPropertyRichTextStyle["ul"] = "UL";
})(DocsBlockItemPropertyRichTextStyle || (DocsBlockItemPropertyRichTextStyle = {}));
